module.exports = __webpack_public_path__ + "img/logo.d87d9910.png";